import { render, staticRenderFns } from "./SearchResultsSortBy.vue?vue&type=template&id=92513a82&"
import script from "./SearchResultsSortBy.vue?vue&type=script&lang=js&"
export * from "./SearchResultsSortBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports